<template>
    <div class="center-branch-form-box">
        <el-form 
            inline 
            :model="form" 
            :rules="rules"
            ref="rule1"
            label-width="150px"
            size="mini"
            class="center-branch-form">
            <!-- 所属分行 -->
            <el-form-item 
                :label="$t('message.cbranch.form1')"
                prop="parent_id">
                <el-select
                    v-model="form.parent_id"
                    @change="handleSelect">
                    <el-option
                        v-for="(item, index) in parent_company"
                        :key="index"
                        :label="item.branchname"
                        :value="item.branch_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- 分行/子公司编号 -->
            <el-form-item 
                :label="$t('message.cbranch.form2')"
                prop="branch_code">
                <el-input
                    v-model="form.branch_code"
                    class="center-branch-form-input"
                    clearable>
                </el-input>
            </el-form-item>
        </el-form>
        <el-form 
            inline 
            :model="form" 
            :rules="rules"
            ref="rule2"
            label-width="150px"
            size="mini"
            class="center-branch-form">
            <!-- 名称（中） -->
            <el-form-item 
                :label="$t('message.cbranch.form3')"
                prop="cn_name">
                <el-input
                    v-model="form.cn_name"
                    class="center-branch-form-input"
                    clearable>
                </el-input>
            </el-form-item>
            <!-- 名称（英） -->
            <el-form-item 
                :label="$t('message.cbranch.form4')"
                prop="en_name">
                <el-input
                    v-model="form.en_name"
                    class="center-branch-form-input"
                    clearable>
                </el-input>
            </el-form-item>
        </el-form>
        <el-form 
            inline 
            :model="form" 
            :rules="rules"
            ref="rule3"
            label-width="150px"
            size="mini"
            class="center-branch-form">
            <!-- 联系人 -->
            <el-form-item 
                :label="$t('message.cbranch.form5')"
                prop="principal">
                <el-input
                    v-model="form.principal"
                    class="center-branch-form-input"
                    clearable>
                </el-input>
            </el-form-item>
            <!-- 电话 -->
            <el-form-item 
                :label="$t('message.cbranch.form6')"
                prop="phone">
                <el-input
                    v-model="form.phone"
                    class="center-branch-form-input"
                    clearable>
                </el-input>
            </el-form-item>
        </el-form>
        <el-form 
            inline 
            :model="form" 
            :rules="rules"
            ref="rule4"
            label-width="150px"
            size="mini"
            class="center-branch-form">
            <!-- 邮箱 -->
            <el-form-item 
                :label="$t('message.cbranch.form7')"
                prop="email">
                <el-popover
                    placement="right-start"
                    trigger="focus">
                    <ul class="center-branch-email-tips">
                        <li>{{$t("public.emailTips")}}</li>
                    </ul>
                    <el-input 
                        type="textarea"
                        v-model="form.email"
                        slot="reference"
                        autosize
                        class="center-branch-form-input">
                    </el-input>
                </el-popover>
            </el-form-item>
            <!-- 地址 -->
            <el-form-item 
                :label="$t('message.cbranch.form8')">
                <el-input
                    v-model="form.address"
                    type="textarea"
                    autosize
                    class="center-branch-form-input"
                    clearable>
                </el-input>
            </el-form-item>
        </el-form>
        <el-form 
            inline 
            :model="form" 
            :rules="rules"
            ref="rule5"
            label-width="150px"
            size="mini"
            class="center-branch-form">
            <!-- 传真 -->
            <el-form-item 
                :label="$t('message.cbranch.form9')">
                <el-input
                    v-model="form.fax"
                    class="center-branch-form-input"
                    clearable>
                </el-input>
            </el-form-item>
            <!-- 分配金额 -->
            <el-form-item 
                :label="$t('message.cbranch.form10')">
                <el-input
                    v-model="amount2"
                    type="number"
                    min="0"
                    class="center-branch-form-input"
                    clearable>
                </el-input>
                <!-- <span class="center-branch-form-remark" v-if="balance!==''">{{$t("public.remarks",{balancer})}}</span> -->
				<span class="center-branch-form-remark" v-if="balance2">剩餘可分配額度：{{balance2}}</span>
            </el-form-item>
        </el-form>
        <!-- 提交按钮插槽 -->
        <el-form label-width="155px" size="mini">
            <el-form-item>
                <slot name="submit"
                    :form="form"
                    :rule="$refs">
                </slot>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { email } from "@/utils/validate";

export default {
    data() {
        let validateEmail = (rule, value, callback) => {
            email(this, false, value, callback);
        }
        return {
			amount:0,
			balance2:0,//实时计算金额
			amount2:0,//分配额度
            form: {
                parent_id: "",
                parentname: "",
                branch_code: "",
                cn_name: "",
                en_name: "",
                principal: "",
                phone: "",
                email: "",
                address: "",
                fax: "",
                amount: ""
            },
            rules: {
                parent_id: [
                    { required: true, message: this.$t("message.cbranch.rule1"), trigger: 'blur' }
                ],
                branch_code: [
                    { required: true, message: this.$t("message.cbranch.rule2"), trigger: 'blur' }
                ],
                cn_name: [
                    { required: true, message: this.$t("message.cbranch.rule3"), trigger: 'blur' }
                ],
                en_name: [
                    { required: true, message: this.$t("message.cbranch.rule4"), trigger: 'blur' }
                ],
                principal: [
                    { required: true, message: this.$t("message.cbranch.rule5"), trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: this.$t("message.cbranch.rule6"), trigger: 'blur' }
                ],
                email: [
                    { required: false, validator: validateEmail, trigger: 'blur' }
                ],
                address: [
                    { required: true, message: this.$t("message.cbranch.rule8"), trigger: 'blur' }
                ],
                fax: [
                    { required: true, message: this.$t("message.cbranch.rule9"), trigger: 'blur' }
                ],
            }
        }
    },
    props: {
        branchDetail: {
            type: Object,
            default: () => { return {} }
        }
    },
    computed: mapState({
        parent_company: state => state.user.parent_company,
        balance: state => state.call.balance,
		branch_detail: state => state.user.branch_detail,
    }),
    watch: {
		balance(){
			this.balance2 = this.balance;
		},
		branch_detail(){
			this.amount = this.branch_detail.amount;
			this.amount2 = this.branch_detail.amount;
		},
		//金额实时计算
		amount2(){
			this.CalculationAmount();
		},
        branchDetail: {
            handler: function(value) {
                let {
                    parent_id = '',
                    parentname = '',
                    branch_code = '',
                    branchname: cn_name = '',
                    en_branchname: en_name = '',
                    principal = '',
                    phone = '',
                    email = '',
                    address = '',
                    fax = '',
                    amount = ''
                } = value;
                this.form = {
                    parent_id,
                    parentname,
                    branch_code,
                    cn_name,
                    en_name,
                    principal,
                    phone,
                    email,
                    address,
                    fax,
                    amount
                }
            },
            immediate: true
        },

    },
	mounted() {
			this.amount = this.branch_detail.amount;
			this.amount2 = this.branch_detail.amount;
	},
    methods: {
        ...mapActions([
            "getBranchBalance"
        ]),
		//金额实时计算
		CalculationAmount(){
			let a = Number(this.amount) || 0;
			let data = a + Number(this.balance);
			this.balance2 =  Number(data) - Number(this.amount2);
			this.form.amount = this.amount2;
		},
        handleSelect(val){ // 下拉菜单更改值触发函数
            this.getBranchBalance(val)
            for(let item of this.parent_company){
                if(item.branch_id == this.form.parent_id){
                    this.form.parentname = item.branchname;
                }
            }
        },
    }
}
</script>

<style scoped>
.center-branch-form>div{
    margin-left: 20px;
}
.center-branch-form-input{
    width: 178px;
}
.center-branch-form-remark{
    margin-left: 10px;
    color: #909399;
}
.center-branch-email-tips{
    list-style-type: circle;
    padding-left: 20px;
    color: #909399;
}
</style>
